import { render, staticRenderFns } from "./QuestionsListItem.vue?vue&type=template&id=32ffa056&scoped=true&"
import script from "./QuestionsListItem.vue?vue&type=script&lang=js&"
export * from "./QuestionsListItem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsListItem.vue?vue&type=style&index=0&id=32ffa056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ffa056",
  null
  
)

export default component.exports